import React, { Component } from "react";
import GRUContainer from "../../components/formbuilder/container/GRUContainer";

class GRUSubscription extends Component {
  render() {
    return (
      <div>
        &nbsp;
        <GRUContainer idForm={this.props.params.id} />
        &nbsp;
      </div>
    );
  }
}

export default GRUSubscription;



// WEBPACK FOOTER //
// ./src/view/inicio/GRUSubscription.js